import type { CSSObject } from "@emotion/react";
import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";
import type { CardHeaderProps } from "./CardHeader.types";

const sizeMap = (header: CardHeaderProps["size"]): CSSObject => {
  switch (header) {
    case "large":
      return vars.semantic.typography["heading-2xlarge-bold"];

    case "small":
      return {
        ...vars.semantic.typography["heading-medium-bold"],
        paddingBottom: vars.spacing[5],
      };

    default:
      return vars.semantic.typography["heading-xlarge-bold"];
  }
};

export const cardHeaderCSS = ({
  align = "left",
  size = "medium",
  separator,
}: Pick<CardHeaderProps, "align" | "size" | "separator">) =>
  css({
    display: "flex",
    justifyContent: align === "center" ? "center" : "initial",

    width: "100%",

    paddingBottom: vars.spacing[6],

    ...(separator && {
      paddingTop: vars.spacing[6],
      borderTop: `${vars.divide.x} solid ${vars.semantic.color.divide}`,
    }),

    "[data-clay-card-section] &": {
      paddingBottom: vars.spacing[5],
    },

    '[data-clay-card-size="large"] [data-clay-card-section] &': {
      paddingBottom: vars.spacing[6],
    },

    '[data-clay-card-inline="true"] [data-clay-card-section] &': {
      display: "inline-flex",
      width: "228px",

      paddingBottom: 0,
    },

    ...sizeMap(size),
    whiteSpace: "pre",
  });
